module.exports = __WEBPACK_EXTERNAL_MODULE__portfolio_not_found_8383e63d__;